module.exports = __webpack_public_path__ + "static/big-trucks-landscape-ef5cab1af027ded895078902c4c656bb.svg";